import type { OfertaLuzModel, TerminoEnergia } from "@api/api";

export class DatosOfertaLuz implements OfertaLuzModel {
    Autoconsumo: boolean = false;
    PotenciaMin: number = 0;
    PotenciaMax: number = 0;
    TerminoPotencia: TerminoEnergia = {
        P1: 0,
        P2: 0,
        P3: null,
        P4: null,
        P5: null,
        P6: null
    };
    TerminoEnergia: TerminoEnergia = {
        P1: 0,
        P2: 0,
        P3: 0,
        P4: null,
        P5: null,
        P6: null
    };
}

